import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkSession = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkSession();
    const onExpired = () => {
      localStorage.removeItem("access_token");
      setUser(null);
      setLoading(false);
    };
    window.addEventListener("gema:session-expired", onExpired);
    return () => window.removeEventListener("gema:session-expired", onExpired);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("access_token", data.access_token);
    setUser({ id: data.id, email: data.email, name: data.name, role: data.role, created_at: data.created_at, armada_id: data.armada_id || null, armada_code: data.armada_code || null, has_pin: data.has_pin === true });
    return data;
  };

  const logout = async () => {
    // Clear the local session immediately so account switching/logout never
    // depends on the network round-trip to the backend.
    localStorage.removeItem("access_token");
    setUser(null);
    try { await api.post("/auth/logout"); } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh: checkSession }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
